<template>
  <v-dialog v-model="forgotDialog" max-width="500">
    <v-card>
      <v-card-title class="headline">Recuperar contraseña</v-card-title>
      <v-card-text>
        <v-alert type="info" dense>
          Ingresa tu correo para enviarte un enlace de recuperación.
        </v-alert>
        <v-text-field
          v-model="forgotUser"
          label="Correo"
          dense
          hide-details="auto"
          class="my-4"
          :rules="[rules.req]"
        />
        <v-alert v-if="forgotError" type="error" dense>{{ forgotError }}</v-alert>
        <v-alert v-if="forgotSuccess" type="success" dense>{{ forgotSuccess }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" :loading="loading" @click="sendRecoveryLink">
          Enviar
        </v-btn>
        <v-btn text @click="forgotDialog = false">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { req } from "@/utils/validations";

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || "http://localhost:8000/api/v1",
});

export default {
  name: "ForgotPasswordDialog",
  props: {
    value: Boolean,
  },
  data() {
    return {
      forgotDialog: this.value,
      forgotUser: "",
      forgotError: null,
      forgotSuccess: null,
      loading: false,
      rules: { req },
    };
  },
  watch: {
    value(val) {
      this.forgotDialog = val;
    },
    forgotDialog(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    async sendRecoveryLink() {
      if (!this.forgotUser) {
        this.forgotError = "Este campo es obligatorio";
        return;
      }
      this.loading = true;
      this.forgotError = null;
      this.forgotSuccess = null;

      try {
        const res = await api.post(`/auth/send_reset_password_email?email=${encodeURIComponent(this.forgotUser)}`);


        this.forgotSuccess =
          res.data.msg || "Se ha enviado un enlace a tu correo";
      } catch (err) {
        this.forgotError =
          err.response?.data?.detail || "No se pudo enviar el enlace";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
